import { ExportButton } from "./ExportButton";

interface Props {
	handleExportToExcel: () => void;
	disabled?: boolean;
}

export const ExcelButton = ({ handleExportToExcel, disabled }: Props) => (
	<ExportButton
		label="EXPORT EXCEL"
		icon="far fa-file-excel"
		color="#217346"
		onClick={handleExportToExcel}
		disabled={disabled}
	/>
);
